/**
 * Custom hook to get sorted list
 * @returns sorting function
 */

const useSort = () => {

    /**
     * Receive list to sort by date
     * @returns sorted list
    */
    const dateSort = (list) => {
        return list.sort((a, b) => {
            let first = new Date(b.date_of_purchase || b.order_date),
                second = new Date(a.date_of_purchase || a.order_date);
            return first - second;
        });
    }

    /**
   * Receive list to sort by name
   * @returns sorted list
  */
    const sort = (list) => {
        return list.sort((a, b) => {
            let first = a.product_name.toLowerCase(),
                second = b.product_name.toLowerCase();

            return first > second ? 1 : second > first ? -1 : 0;
        });
    }

    return { dateSort, sort };
}

export default useSort;